import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import {
  getCreatingOrUpdatingPricingGroup,
  getIsLoadingPricingGroups,
  getPricingGroupedByCustomer,
  getPricingGroups,
  getSelectedPricingGroup,
} from './pricing.selectors';
import { getSelectedOrganizationInfo } from '@boma/supplier-portal/shared/state';
import { take, tap } from 'rxjs/operators';
import { loadPricings } from './pricing.actions';

export type groupBy = 'Location' | 'Product' | 'None';

@Injectable()
export class PricingFacade {
  isLoading$ = this.store.select(getIsLoadingPricingGroups);
  pricingGroupsByCustomer$ = this.store.select(getPricingGroupedByCustomer);
  pricingGroups$ = this.store.select(getPricingGroups);
  selectedPricingGroup$ = this.store.select(getSelectedPricingGroup);
  isCreatingOrUpdating$ = this.store.select(getCreatingOrUpdatingPricingGroup);

  constructor(private store: Store) {}

  loadPricingForSelectedEntity(params?: {
    promotions?: boolean;
    deletedEntries?: boolean;
    locationIds?: string[];
    customerIds?: string[];
    productIds?: string[];
    groupBy?: groupBy;
  }) {
    return this.store.select(getSelectedOrganizationInfo).pipe(
      take(1),
      tap((x) =>
        this.dispatch(
          loadPricings({
            payload: {
              entityId: x.id,
              params: {
                customerIds: params?.customerIds || [],
                locationIds: params?.locationIds || [],
                productIds: params?.productIds || [],
                groupBy: params?.groupBy || 'Location',
                deletedEntries: params?.deletedEntries || false,
                promotions: params?.promotions || false,
              },
            },
          })
        )
      )
    );
  }

  dispatch(action: Action) {
    this.store.dispatch(action);
  }
}
